// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from '@/MchOmsApp';
import VueCookies from 'vue-cookies';
Vue.config.productionTip = false;
Vue.config.ignoredElements = ["control"]; //取得預設語系

var locale = localStorage.getItem('locale') || 'tw'; //export default i18n;
//Vue.use(MyPlugin); 

Vue.use(VueCookies); //Vue.use(moment);

window["VF"] = Vue; //Vue.config.ignoredElements = [/Faq/i, /FaqItemList/i, /Description/i,/control/i];

Vue.config.ignoredElements = [/[a-z]+/i];
/* eslint-disable no-new */

new Vue({
  el: '#app',
  data: function data() {
    return {// Bind our event bus to our $root Vue model
    };
  },
  created: function created() {
    window["vueComponent"] = this;
  },
  render: function render(h) {
    return h('App');
  },
  components: {
    App: App
  } //template: '<App/>'

});